var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wheel-container"},[_c('canvas',{ref:"wheelCanvas",staticClass:"canvas",attrs:{"width":"500","height":"500"}}),_c('img',{staticClass:"round",attrs:{"src":require("../../../../../src/assets/images/wheel/wheel1.gif"),"alt":""}}),_c('audio',{ref:"sound",attrs:{"src":require("../../../../assets/images/wheel/wheel.mp3")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }